var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B1A21",
    d: "M5.16 3.18V.12h-2.1v3.06H.02v2.1h3.04v3.06h2.1V5.28h3.08v-2.1z"
  })));
};
export { SvgPlusIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgOSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNS4xNiAzLjE4VjAuMTE5OTk5SDMuMDZWMy4xOEgwLjAyMDAwMDFWNS4yOEgzLjA2VjguMzRINS4xNlY1LjI4SDguMjRWMy4xOEg1LjE2WiIgZmlsbD0iIzBCMUEyMSIvPgo8L3N2Zz4K";